<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-row>
                    <v-col cols="10">
                        <m-text-field label="Código do grupo: "
                                      class="required"
                                      v-input-filter="[$filters.numeric]"
                                      maxlength="150"
                                      v-model="model.cd_grupo"
                                      outlined
                                      v-uppercase />
                    </v-col>
                    <v-col cols="2" class="mt-7">
                        <v-btn class="transition" color="primary" rounded @click="inserir">
                            Salvar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-layout class="d-flex justify-space-between mt-2">
                    <v-btn class="transition" style="margin-left:2.5px" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="mr-4 transition" color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-if="filter_open" class="mt-4 ml-2" @submit.prevent="filtrar">
                        <v-row>
                            <v-col cols="12">
                                <m-text-field outlined label="Código do grupo:" :rules="[$rules.required]" v-model="filters.cd_grupo" v-uppercase />
                            </v-col>
                        </v-row>
                        <v-row class="justify-space-between">
                            <v-col cols="6" md="3">
                                <v-btn color="secondary" block @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-btn color="primary" type="submit" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <DataTable ref="datatable" url="/painel/gruposfinanciamento/listar"
                           class="pt-2 data-table-overlow"
                           :headers="headers"
                           :params="params"
                           :filter="dtFiltro">
                    <template v-slot:items="{item}">
                        <td>{{ item.cd_grupo }}</td>
                        <td>
                            <v-col xs12>
                                <v-btn icon>
                                    <v-icon @click="deletar(item.cd_grupo)">ol-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { alert, notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import * as Qs from 'qs'

  export default {
    name: 'GruposFinanciamento',
    data: () => ({
      filter_open: false,
      pagination: {
        sortBy: [ 'cd_grupo' ], descending: [ true ]
      },
      dtFiltro: {},
      model: {
        cd_grupo: ''
      },
      headers: [
        { text: 'Código do grupo', value: 'cd_grupo' },
        { text: '', value: '' }
      ],
      filters: {
        cd_grupo: ''
      }
    }),
    computed: {
      params () {
        return { pagination: this.pagination }
      }
    },
    methods: {
      downloadReport () {
        const headersFiltrados = this.headers
        const encoded_params = Qs.stringify({
          filters: this.dtFiltro,
          headers: headersFiltrados.map(header => header.value),
          headers_formatado: headersFiltrados.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/grup-config/financing-group/download?${encoded_params}`)
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      async inserir () {
        if (this.model.cd_grupo) {
          alert({
            text: `Tem certeza que deseja inserir o grupo ${this.model.cd_grupo}?\nApós a confirmação, todas as vendas para esse grupo passarão a emitir, além do PAC, o contrato do banco.`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                try {
                  await this.$http.post('/painel/gruposfinanciamento/inserir', { cd_grupo: this.model.cd_grupo })
                  this.$refs.datatable.reload(true)
                  this.model.cd_grupo = ''
                  notification(AlertTypes.SUCCESS, 'Código do grupo inserido com sucesso.')
                } catch (e) {
                  notification(AlertTypes.ERROR, e, 'Falha ao inserir o código do grupo')
                }
              }
            }
          })
        } else {
          notification(
            AlertTypes.WARN,
            'Informe o código do grupo antes de salvá-lo.'
          )
        }
      },
      async deletar (cd_grupo) {
        try {
          alert({
            text: `Tem certeza que deseja remover o grupo ${cd_grupo}?\nApós a confirmação, as vendas para esse grupo não incluirão o contrato do banco.`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                await this.$http.delete(`/painel/gruposfinanciamento/delete/${cd_grupo}`)
                await this.$refs.datatable.reload(true)
                notification(AlertTypes.SUCCESS, 'Grupo excluído com sucesso.')
              }
            }
          })
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível deletar o grupo ' + cd_grupo)
        }
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          this.dtFiltro = { ...this.filters }
        }
      },
      limpar () {
        this.filters = {
          cd_grupo: ''
        }
        this.dtFiltro = { ...this.filters }
      }
    }
  }
</script>

<style scoped>

</style>
